/* eslint-disable no-void */
import { FunctionComponent } from 'react';
import * as vp from 'vopay';
import FileTemplateFormRender from './FileTemplateForm';
import { FileTemplateForm } from './types';
import { useClientData } from '@/providers/ClientData.provider';

type FC = FunctionComponent;

const DownloadTemplate: FC = () => {
  const {
    response: { Country },
  } = useClientData();

  const handlers = {
    onDownload: (values: FileTemplateForm) => {
      let fileName = 'eft.csv';

      if (values.Product === 'eft') {
        fileName = 'eft.csv';
      } else if (values.Product === 'e-Transfer') {
        fileName = 'emt.csv';
      } else if (values.Product === 'ACH') {
        fileName = 'ach.csv';
      }
      void fetch(`/files/beneficiary/${fileName}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          // Create blob link to download
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${fileName}`);

          // Append to html link element page
          document.body.appendChild(link);

          // Start download
          link.click();

          // Clean up and remove the link
          link.parentNode?.removeChild(link);
        });
    },
  };
  const { Box, Title } = vp;
  return (
    <Box flx="col">
      <Box mb="md" jc="sb">
        <Title title="File Templates" />
      </Box>
      <Box flx="col" jc="sb" mt="md">
        In this contacts section you are able to save a payment file of up to 5,000 contacts payment instructions in one
        file.
        <Box flx="col" jc="sb" mt="md">
          <ol style={{ paddingLeft: '40px' }}>
            <li>
              Select the type of payment you wish to make and press &#39;Download&#39;. This will download a .csv file.
            </li>
            <li>
              Fill out the downloaded .csv file for all the beneficiaries that you wish to send funds to. Please note
              that all fields must be filled.
            </li>
            <li>Go to the ‘File Upload’ section and;</li>
            <li>Select the type of payment that matches the .csv file you are uploading.</li>
            <li>Press the &#39;Choose File&#39; button and select the file that you wish to upload.</li>
            <li>Once the file is selected press the &#39;Submit&#39; button.</li>
          </ol>
        </Box>
      </Box>
      <Box flx="col" mt="md">
        <FileTemplateFormRender
          defaultValues={{
            Service: 'Debit',
            Product: Country === 'US' ? 'ACH' : 'EFT',
            Currency: Country === 'US' ? 'USD' : 'CAD',
          }}
          handlers={handlers}
        />
      </Box>
    </Box>
  );
};

export default DownloadTemplate;
